module.exports = __webpack_public_path__ + "img/operaguru.92b2900b.png";